import axios from "axios";
import SERVER from '@/API/url';

const UserAccountStore = {
    namespaced: true,
    state: {
        
    },
    getters: {

    },
    mutations: {

    },
    actions: {

        // 로그인
        login: ({commit}, params) => { 
            
            return new Promise((resolve, reject) => {
                axios.post(SERVER.URL + '/api/UserAccount/login', params,
                { headers: SERVER.HEADERS }
                ).then(res => {
                    //console.log(res);
                    resolve(res.data);
                })
                .catch(err => {
                    console.log(err.message);
                    reject(err.message);
                });
            })
        },

        // 로그아웃
        logout: ({commit}, params) => { 
            
            return new Promise((resolve, reject) => {
                axios.post(SERVER.URL + '/api/UserAccount/logout?useruid='+params.useruid, params,
                { headers: SERVER.HEADERS }
                ).then(res => {
                    //console.log(res);
                    resolve(res.data);
                })
                .catch(err => {
                    console.log(err.message);
                    reject(err.message);
                });
            })
        },

        // 자동로그인 - refreshtoken 이용해서 재발급
        refreshToken: ({commit}, params) => { 

            return new Promise((resolve, reject) => {
                axios.post(SERVER.URL + '/api/UserAccount/refresh_token/', params,
                { 
                    headers: {
                        ...SERVER.HEADERS,
                    }
                }
                ).then(res => {
                    //console.log(res);
                    resolve(res.data);
                })
                .catch(err => {
                    console.log(err.message);
                    reject(err.message);
                });
            })
        },

        // 사용자 정보 조회
        getUserData: ({commit}, params) => { 
            
            return new Promise((resolve, reject) => {
                axios.get(SERVER.URL + '/api/UserAccount/GetUserData?useruid='+params.useruid,
                { 
                    headers: {
                        ...SERVER.HEADERS,
                    }
                }
                ).then(res => {
                    //console.log(res);
                    resolve(res.data);
                })
                .catch(err => {
                    console.log(err.message);
                    reject(err.message);
                });
            })
        },

        // 회원가입
        join: ({commit}, params) => { 

            return new Promise((resolve, reject) => {
                axios.post(SERVER.URL + '/api/UserAccount/join/', params,
                { 
                    headers: {
                        ...SERVER.HEADERS,
                    }
                }
                ).then(res => {
                    //console.log(res);
                    resolve(res.data);
                })
                .catch(err => {
                    console.log(err.message);
                    reject(err.message);
                });
            })
        },

        // 회원정보 수정
        edit: ({commit}, params) => { 

            return new Promise((resolve, reject) => {
                axios.put(SERVER.URL + '/api/UserAccount/edit/' + params.useruid, params,
                { 
                    headers: {
                        ...SERVER.HEADERS,
                    }
                }
                ).then(res => {
                    //console.log(res);
                    resolve(res.data);
                })
                .catch(err => {
                    console.log(err.message);
                    reject(err.message);
                });
            })
        },

        // 비밀번호 변경
        updatepassword: ({commit}, params) => { 

            return new Promise((resolve, reject) => {
                axios.post(SERVER.URL + '/api/UserAccount/updatepassword', params,
                { 
                    headers: {
                        ...SERVER.HEADERS,
                    }
                }
                ).then(res => {
                    //console.log(res);
                    resolve(res.data);
                })
                .catch(err => {
                    console.log(err.message);
                    reject(err.message);
                });
            })
        },

        // 비밀번호 변경하기 - 이메일 발송
        sendPasswordResetEmail: ({commit}, params) => { 
            
            return new Promise((resolve, reject) => {
                axios.post(SERVER.URL + '/api/UserAccount/sendPasswordResetEmail/'+params.email, {},
                { 
                    headers: {
                        ...SERVER.HEADERS,
                    }
                }
                ).then(res => {
                    //console.log(res);
                    resolve(res.data);
                })
                .catch(err => {
                    console.log(err.message);
                    reject(err.message);
                });
            })
        },

        // 비밀번호 변경 (비밀번호 찾기)
        resetPassword: ({commit}, params) => { 

            return new Promise((resolve, reject) => {
                axios.post(SERVER.URL + '/api/UserAccount/resetPassword', params,
                { 
                    headers: {
                        ...SERVER.HEADERS,
                    }
                }
                ).then(res => {
                    //console.log(res);
                    resolve(res.data);
                })
                .catch(err => {
                    console.log(err.message);
                    reject(err.message);
                });
            })
        },
    }
}

export default UserAccountStore